/* eslint-disable react/style-prop-object */
import { Box, Typography } from "@husqvarna/ui-core";
import { FormattedMessage } from "react-intl";
import clsx from "clsx";
import "./MowerCapacityBadge.scss";

export type MowerCapacityBadgeProps = {
  remainingCapacity: number;
  small?: boolean;
};

const MowerCapacityBadge = ({
  remainingCapacity,
  small = false,
}: MowerCapacityBadgeProps) => { 
  
  const formatRemainingCapacity = (): string => {
    return `${remainingCapacity}%`;
  }

  return (
  <Box
    className={clsx("tcsp-capacity-badge", {"tcsp-capacity-badge--error" : remainingCapacity <= 0 })}
    px={2}
    py={1}
    br={2}
    alignItems="center"
    component="div"
  >
    <Typography variant={small ? "Button" : "Label"} tag="p">
      {small && (
        formatRemainingCapacity()
      )}
      {!small && (
        <FormattedMessage
          id="projects.equipment.mowerSelection.remainingMachineCapacity"
          defaultMessage="{remainingCapacity} Remaining capacity"
          values={{remainingCapacity: formatRemainingCapacity()}}
        />
      )}
    </Typography>
  </Box>
)};

export default MowerCapacityBadge;